import React from 'react';
import { Trans } from '@lingui/macro';

import { Container, Section, Grid, Typography } from 'components';
import { StyledColumn } from 'components/StyledCommon';
import { ContentQuote } from './styled';

export const Quotes = () => {
    return (
        <Section background="white">
            <Container>
                <Grid alignCenter alignItems="center">
                    <StyledColumn cols={4}>
                        <ContentQuote>
                            <Typography
                                variant="h4"
                                fontWeight={400}
                                color="background"
                                spaceBottom="medium"
                            >
                                <Trans>
                                    Excuse me, I need to speak to your
                                    manager...
                                </Trans>
                            </Typography>
                            <Typography variant="bodyl" spaceBottom="medium">
                                <Trans>
                                    ...because Yousician is AH-MAY-ZIIIIING!!!
                                </Trans>
                            </Typography>
                            <Typography variant="bodyl">
                                <Trans>Cara K</Trans>
                            </Typography>
                        </ContentQuote>
                    </StyledColumn>
                    <StyledColumn cols={4}>
                        <ContentQuote>
                            <Typography
                                variant="h4"
                                fontWeight={400}
                                color="background"
                                spaceBottom="medium"
                            >
                                <Trans>Amazing App!</Trans>
                            </Typography>
                            <Typography variant="bodyl" spaceBottom="medium">
                                <Trans>
                                    I've wanted to learn the guitar my whole
                                    life and now I am actually doing it!
                                </Trans>
                            </Typography>
                            <Typography variant="bodyl">
                                <Trans>Kurt V</Trans>
                            </Typography>
                        </ContentQuote>
                    </StyledColumn>
                    <StyledColumn cols={4}>
                        <ContentQuote>
                            <Typography
                                variant="h4"
                                fontWeight={400}
                                color="background"
                                spaceBottom="medium"
                            >
                                <Trans>Easy to use</Trans>
                            </Typography>
                            <Typography variant="bodyl" spaceBottom="medium">
                                <Trans>
                                    Yousician brings you along little by little
                                    and before you know it, you're playing. Love
                                    it.
                                </Trans>
                            </Typography>
                            <Typography variant="bodyl">
                                <Trans>Rob A</Trans>
                            </Typography>
                        </ContentQuote>
                    </StyledColumn>
                </Grid>
            </Container>
        </Section>
    );
};
